import { Component, OnDestroy, OnInit } from '@angular/core';
import { convertDesignIdToCommunicationId, trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DesignService } from 'src/app/state';
import { ProcessingHistoryDocumentService } from 'src/app/state/processing-history-document.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-processing-history-document-link',
  templateUrl: './processing-history-document-link.component.html',
  standalone: false,
})
export class ProcessingHistoryDocumentLinkComponent implements OnInit, OnDestroy {
  public readonly isDesignLoading$ = this.designService.loading$;
  public readonly processingHistoryDocuments$ =
    this.processingHistoryDocumentService.processingHistoryDocuments$;
  public readonly isLoading$ = this.processingHistoryDocumentService.loading$;
  public readonly error$ = this.processingHistoryDocumentService.error$;
  public readonly siteUrl = environment.sharePointPHDSiteUrl;
  public readonly trackByRef = trackByRef;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly processingHistoryDocumentService: ProcessingHistoryDocumentService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(
          map(convertDesignIdToCommunicationId),
          switchMap((communicationId) =>
            this.processingHistoryDocumentService.loadByCommunicationId(communicationId)
          )
        )
        .subscribe()
    );
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
